export const getBaseUrl = (): string => {
  return (
    document.getElementsByTagName("base")?.[0]?.getAttribute("href") ?? "/"
  );
};

export function normalizeUrl(url: string, basename: string): string {
  return `${basename.replace(/\/+$/, "")}/${url.replace(/\/+$/, "")}`;
}
